export default __webpack_public_path__ + "static/media/ct-logo.808dc830.png";